import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import parseRecordTitle from '../helpers/record-title-parser';
import { RestApiForm } from "../types";

interface Props {
  record: Record<string, any>,
  restForm: RestApiForm,
}

const AppLinkPickerItem: React.FC<Props> = ({
  record,
  restForm,
}) => {
  const primaryValue = parseRecordTitle(record, restForm);
  return (
    <ListItemText
      primary={primaryValue}
    />
  );
};

export default AppLinkPickerItem;
